import React from 'react'
import './style/Services.css'
import reactDOM from 'react-dom';
function Services(props) {
   
return (
     <div className='container services' id='services'>
          <div className="heading">
          <h5 className="head">Services</h5>
          <p className='skills'>The services I can provide to you.</p>
        </div>
        <div className='row'>
           {/** testimonial1 */}
                <div className='col-lg-4 col-md-4 col-sm-4'>
                    
                        <div className='servicesContainer container1'>
                       <div className='responsive'>
                           <i className="fas fa-laptop-code laptop"></i>
                           <i className="fas fa-mobile-alt  phone"></i>
                        </div> 
                       
                        <h6 className='servicesName'>Responsive Design</h6>
                        <p className='servicesText'>I develope responsive applications for every device and all screen sizes.</p>
                       </div>
                </div>

               {/** service 2 */}
                 
               {/** testimonial1 */}
               <div className='col-lg-4 col-md-4 col-sm-4'>
                    
                    <div className='servicesContainer container2'>
                   <div className='responsive2'>
                    <i class="fas fa-code"></i>
                    </div> 
                   
                    <h6 className='servicesName'>High Quality Applications</h6>
                    <p className='servicesText'>Using full stack web technologies, I work on your product from scratch until you be satisfied </p>
                   </div>
            </div>

           {/** service 2 */}

           {/** testimonial1 */}
                <div className='col-lg-4 col-md-4 col-sm-4'>
                    
                        <div className='servicesContainer container3'>
                       <div className='responsive'>
                       <i class="fas fa-drafting-compass"></i>
                        </div> 
                       
                        <h6 className='servicesName'>Application Modeling</h6>
                        <p className='servicesText'>I integrate set of diagrams for specifying, visualizing, and documenting your product. </p>
                       </div>
                </div>

               {/** service 2 */}  
                
                
        </div>
     </div>
      
  
  );
}

export default Services;
